/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { FormattedMessage } from 'react-intl-next';
import { cssMap, jsx } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { SlideAnimationWrapper } from '../SlideAnimationWrapper';
import { messages } from '../i18n';
import { type ViralSettingsProps } from './types';
import { useViralSettingsContext } from './ViralSettingsContext';
import OpenInviteCheckbox from './OpenInviteCheckbox';
import DirectAccessCheckboxList from './DirectAccessCheckboxList';
import { getProductTitle } from '../../utils';

const styles = cssMap({
	heading: {
		color: token('color.text.subtlest', '#626F86'),
		font: token(
			'font.heading.xxsmall',
			'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
		),
	},
	formSection: {
		marginBottom: token('space.200', '16px'),
	},
});

export const ViralSettings = ({ product }: ViralSettingsProps) => {
	const {
		viralSettingsByDomain,
		eligibleDomains,
		showOpenInvite,
		onOpenInviteChange,
		handleViralSettingsByDomainCheckbox,
		openInviteEnabled,
	} = useViralSettingsContext();
	const productTitle = getProductTitle(product);

	return (
		<SlideAnimationWrapper shouldTriggerAnimation={showOpenInvite || eligibleDomains.length > 0}>
			<Box testId="testId-invite-people-viral-settings" xcss={styles.formSection}>
				<Inline alignBlock="center" spread="space-between">
					{/* TODO: fix this when the font weight in Text is fixed: https://product-fabric.atlassian.net/servicedesk/customer/portal/3517/HDS-2561 */}
					<div data-test-id="testId-invite-people-viral-settings-title" css={styles.heading}>
						<FormattedMessage
							{...messages.viralSettingsHeading}
							values={{ product: productTitle }}
						/>
					</div>
				</Inline>
				<OpenInviteCheckbox
					show={showOpenInvite}
					isChecked={openInviteEnabled}
					onChange={onOpenInviteChange}
				/>
				<DirectAccessCheckboxList
					viralSettingsByDomain={viralSettingsByDomain}
					onChange={handleViralSettingsByDomainCheckbox}
				/>
			</Box>
		</SlideAnimationWrapper>
	);
};

export default ViralSettings;
